module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    class: _vm.classes
  }, [_c('dt', {
    staticClass: "dn-accordion__trigger",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "dn-accordion__trigger-inner"
  }, [_vm._t("trigger")], 2), _vm._v(" "), _c('div', {
    staticClass: "dn-accordion__trigger-icon-container"
  }, [_c('dn-icon', {
    staticClass: "dn-accordion__trigger-icon",
    attrs: {
      "icon": _vm.icon
    }
  })], 1)]), _vm._v(" "), _c('dd', {
    ref: "body",
    staticClass: "dn-accordion__body"
  }, [_vm._t("body")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6cb4480","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/accordions/Accordion.vue
// module id = 291
// module chunks = 1